import React from 'react';
import { useTranslation } from 'react-i18next';
import '../cpdpro.css';

export default function CpdProFaqPage() {
  const { t } = useTranslation();

  return (
    <>
      <section className="cpd-page-hero">
        <div className="container">
          <h1>{t('cpd.faq.title', 'FAQ')}</h1>
          <p className="muted">{t('cpd.faq.subtitle', 'Answers to the most common questions.')}</p>
        </div>
      </section>

      <section className="cpd-faq">
        <div className="container">
          <h2>{t('faq.title', 'Frequently Asked Questions')}</h2>
          <div className="faq-accordion">
            <details className="faq-item">
              <summary>{t('faq.q1', 'What is CPD?')}</summary>
              <p>{t('faq.a1', 'Continuing Professional Development (CPD) is the ongoing development of professional skills and knowledge.')}</p>
            </details>
            <details className="faq-item">
              <summary>{t('faq.q2', 'Are the certificates recognized?')}</summary>
              <p>{t('faq.a2', 'Our certificates are designed for CPD purposes. Always check requirements of your specific professional body.')}</p>
            </details>
            <details className="faq-item">
              <summary>{t('faq.q3', 'Can I track my progress?')}</summary>
              <p>{t('faq.a3', 'Yes—your dashboard shows completions, points, and downloadable certificates.')}</p>
            </details>
            <details className="faq-item">
              <summary>{t('faq.q4', 'How do I download certificates?')}</summary>
              <p>{t('faq.a4', 'After passing a test, you can download your certificate from your history at any time.')}</p>
            </details>
          </div>
        </div>
      </section>
    </>
  );
}


